import React from 'react'
import RILightbox from 'react-image-lightbox'
import 'react-image-lightbox/style.css'
import { useTheme } from '@mui/material/styles'

const Lightbox = (props: React.ComponentProps<typeof RILightbox>) => {
  const theme = useTheme()
  return (
    <RILightbox
      {...props}
      reactModalStyle={{
        // In our use-cases the lightbox always is the top modal so far. So let's enforce this by taking a z-index that's higher than
        // MUI's z-index range of modal. But let's also make sure snackbars and tooltips keep working.
        // See: https://mui.com/material-ui/customization/z-index/
        //
        // Make sure to update packages/main/src/app/settings/components/Media/Media.less if we change this z-index.
        overlay: { zIndex: props.reactModalStyle?.overlay?.zIndex ?? theme.zIndex.modal + 1 }
      }}
    />
  )
}

export default Lightbox
